/* eslint-disable sonarjs/table-header */
import React, { useCallback, useEffect, useRef, useState } from 'react';
// import cx from 'classnames';
// import ReactPaginate from 'react-paginate';

import { useNavigate } from 'react-router-dom';
import MenuIcon from '../../media/icons/menu.svg';
import NextIcon from '../../media/icons/page-next.svg';
import PrevIcon from '../../media/icons/page-prev.svg';
import MoveProjectModal from './MoveProjectModal';

const PAGE_SIZE = 10;

const UsersList = ({ users, projects, handlePageClick, total, page, fetchData }) => {
  const navigate = useNavigate();

  const containerRef = useRef(null);
  const buttonRef = useRef(null);

  const [userMenu, setUserMenu] = useState(undefined);
  const [moveOpen, setMoveOpen] = useState(false);

  const pageCount = Math.max(1, Math.ceil(total / PAGE_SIZE));

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the ref exists and the click target is NOT inside the menu ref or menu button ref
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        !buttonRef.current.contains(event.target)
      ) {
        setUserMenu(undefined);
      }
    };

    // Only add listener if the element is open
    if (userMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [userMenu]);

  const handleMenuOpen = useCallback(
    (id) => {
      if (userMenu === id) {
        setUserMenu(undefined);
      } else {
        setUserMenu(id);
      }
    },
    [userMenu]
  );

  return (
    <>
      <div className="main-table">
        {users.length > 0 ? (
          <table className="projects-table">
            <thead>
              <tr>
                <th>Username</th>
                <th className="w-130">Project</th>
                <th className="w-6" />
              </tr>
            </thead>
            <tbody>
              {users?.map((user) => {
                return (
                  <tr key={user.id}>
                    <td>
                      <span className="mx-4">{user.name}</span>
                    </td>
                    <td>
                      {user.project?.name && (
                        <div
                          title={user.project?.name}
                          style={{
                            backgroundColor: `${user.project?.accent_colour || '#37C2D7'}40`,
                            color: user.project?.accent_colour || '#37C2D7',
                          }}
                          className="rounded-full py-1 px-3 text-center truncate w-fit"
                        >
                          {user.project?.name}
                        </div>
                      )}
                    </td>
                    <td className="flex !px-4 h-[57px] float-right">
                      <button
                        ref={userMenu === user.id ? buttonRef : undefined}
                        onClick={() => handleMenuOpen(user.id)}
                        className="my-auto"
                        type="button"
                      >
                        <img style={{ width: '100%', height: '100%' }} src={MenuIcon} alt="" />
                      </button>
                      {userMenu === user.id && (
                        <div ref={containerRef} className="absolute right-7 mt-10 z-10">
                          <div className="bg-white shadow-xl/10">
                            {user.project && (
                              <button
                                type="button"
                                onClick={() => navigate(String(user.project.id))}
                                className="block px-4 py-2 text-base text-gray-700 w-full text-left
                            hover:bg-gray-100 font-normal"
                              >
                                View Project
                              </button>
                            )}
                            <button
                              type="button"
                              onClick={() => setMoveOpen(user)}
                              className="block px-4 py-2 text-base text-gray-700 w-full text-left
                            hover:bg-gray-100 font-normal"
                            >
                              Move Projects
                            </button>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <table className="reports-table mt-14">
            <tbody>
              <tr>
                <td>No users to display</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
      <br />

      <div className="flex float-right">
        <div className="text-base flex items-center justify-center mx-2">
          Page {page + 1} of {pageCount}
        </div>
        <button
          type="button"
          onClick={() => handlePageClick('prev')}
          disabled={page + 1 === 1}
          className="bg-accent rounded-md p-2 flex justify-center items-center m-1 disabled:bg-accent/20 disabled:cursor-not-allowed"
        >
          <img className="w-2 h-2 absolute" src={PrevIcon} alt="p" />
        </button>

        <button
          type="button"
          onClick={() => handlePageClick('next')}
          disabled={page + 1 === pageCount}
          className="bg-accent rounded-md p-2 flex justify-center items-center m-1 disabled:bg-accent/20 disabled:cursor-not-allowed"
        >
          <img className="w-2 h-2 absolute" src={NextIcon} alt="n" />
        </button>
      </div>
      {moveOpen && (
        <MoveProjectModal
          handleMoveProjectModalClose={() => setMoveOpen(undefined)}
          user={moveOpen}
          projects={projects}
          fetchData={fetchData}
        />
      )}
    </>
  );
};

export default UsersList;
